if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        /* ------------------------------
           YOUR CUSTOM CONFIG
        ------------------------------ */

        const bonusVariantId   = 45030679281839;
        const triggerProductId = '1956758028330';

        const productId     = this.form.querySelector('[name="product-id"]')?.value;
        const mainVariantId = this.form.querySelector('[name="id"]')?.value;

        const coverEl = this.closest('.product_form_cover');
        const qtyInput = coverEl?.querySelector('input[name="quantity"]');
        const mainQty  = qtyInput ? parseInt(qtyInput.value, 10) : 1;

        /* ------------------------------
           GET SELLING PLAN (IMPORTANT)
        ------------------------------ */

        const sellingPlanInput = this.form.querySelector('[name="selling_plan"]');
        const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

        /* ------------------------------
           CHECK BONUS ALREADY EXISTS
        ------------------------------ */

        let hasBonus = false;

        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          hasBonus = cart.items.some(
            item => item.variant_id === bonusVariantId
          );
        } catch (e) {
          console.error('Cart fetch failed', e);
        }

        /* ------------------------------
           BUILD MAIN ITEM
        ------------------------------ */

        const mainItem = {
          id: parseInt(mainVariantId, 10),
          quantity: parseInt(mainQty, 10),
        };

        // Add selling plan if exists (for subscription products)
        if (sellingPlanId && sellingPlanId !== '') {
          mainItem.selling_plan = parseInt(sellingPlanId, 10);
        }

        const items = [mainItem];

        /* ------------------------------
           BONUS PRODUCT LOGIC
        ------------------------------ */

        if (productId === triggerProductId && !hasBonus) {
          items.push({
            id: bonusVariantId,
            quantity: 1,
          });
        }

        /* ------------------------------
           SEND TO CART
        ------------------------------ */

        const payload = { items };

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);

        try {
          const response = await fetch(routes.cart_add_url, config)
            .then(r => r.json());

          if (response.status) {
            console.warn('Cart error:', response);

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainVariantId,
            cartData: response,
          });

          this.cart.renderContents(response);

        } catch (e) {
          console.error('Fetch error', e);
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');

          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}